/**
 * PATH: packages/ui/src/kanban/components/cardDetailContent.ts
 * FILE_ID: UI-KANBAN-CARD-DETAIL-002
 * PURPOSE: Classify whether an optional card-detail slot has renderable content.
 * WHY: Slot producers must return null rather than reserve empty card space.
 * FLOW: ReactNode input → child normalization → boolean result.
 * RELATED: KanbanCardDetailSlot.tsx; Time and Smart Time view producers.
 */
import { Children, type ReactNode } from 'react'

export function hasRenderableCardDetail(content: ReactNode): boolean {
  return content !== '' && Children.toArray(content).length > 0
}
